export default __webpack_public_path__ + "static/media/full-video-kind.4c4356fb.svg";